import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Redirects /submit/streamer-university/* to /streamer/* equivalents.
 * This route has no :school param — always redirect on mount.
 */
const StreamerUniversityRedirect = ({ targetPath }) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    navigate(targetPath, { replace: true, state: location.state });
  }, [navigate, targetPath, location.state]);

  return null;
};

export default StreamerUniversityRedirect;
